// History Weekly Lessons - Scheme of Work
// Years 11, 12, 13 - Vanuatu National Syllabus

export const historyWeeklyLessons = {
  year11: {
    term1: {
      weeks: [
        {
          week: 1,
          strand: "Skills of History",
          topic: "Introduction to History",
          learningOutcomes: ["Define the term History", "Explain why studying History is important", "Identify different periods in history"],
          activities: ["Class discussion on personal history", "Timeline creation activity", "History in daily life examples"],
          resources: ["Textbook Ch. 1", "Timeline templates", "Local history artifacts"],
          assessment: "Diagnostic test on prior knowledge"
        },
        {
          week: 2,
          strand: "Skills of History",
          topic: "Personalizing History",
          learningOutcomes: ["Explain historical meanings of village and personal names", "Express viewpoints about family history", "Understand how past shapes present"],
          activities: ["Research own name origins", "Family tree construction", "Interview elder family members"],
          resources: ["Interview guides", "Family tree templates", "Recording devices"],
          assessment: "Family history presentation"
        },
        {
          week: 3,
          strand: "Skills of History",
          topic: "Historical Sources - Part 1",
          learningOutcomes: ["Define oral traditions", "Define primary sources", "Define secondary sources"],
          activities: ["Source identification exercises", "Primary vs secondary sorting", "Oral tradition storytelling"],
          resources: ["Sample documents", "Photos", "Newspaper clippings"],
          assessment: "Source identification quiz"
        },
        {
          week: 4,
          strand: "Skills of History",
          topic: "Historical Sources - Part 2",
          learningOutcomes: ["Differentiate between primary and secondary sources", "Explain links between source types", "Distinguish oral traditions from testimonies"],
          activities: ["Source analysis practice", "Reliability assessment", "Group source evaluation"],
          resources: ["Document analysis worksheets", "Various source samples"],
          assessment: "Source analysis assignment"
        },
        {
          week: 5,
          strand: "Skills of History",
          topic: "Historical Enquiry",
          learningOutcomes: ["Define historical enquiry", "List steps for conducting enquiry", "Select relevant information from sources"],
          activities: ["Research question formulation", "Information gathering practice", "Hypothesis development"],
          resources: ["Research guides", "Library resources", "Internet access"],
          assessment: "Research proposal submission"
        },
        {
          week: 6,
          strand: "Early History of Vanuatu",
          topic: "Origins of Vanuatu",
          learningOutcomes: ["Name traditional gods", "Recite custom creation stories", "Identify evidence of traditional stories"],
          activities: ["Storytelling session", "Map creation of sacred sites", "Elder guest speaker"],
          resources: ["Custom story collections", "Maps of Vanuatu", "Visual aids"],
          assessment: "Creation story presentation"
        },
        {
          week: 7,
          strand: "Early History of Vanuatu",
          topic: "Scientific Evidence vs Oral Traditions",
          learningOutcomes: ["Describe evidence of first people", "Compare scientific and oral tradition evidence", "Analyze archaeological findings"],
          activities: ["Evidence comparison chart", "Archaeological site study", "Documentary viewing"],
          resources: ["Archaeological reports", "Documentary films", "Research articles"],
          assessment: "Comparative analysis essay"
        },
        {
          week: 8,
          strand: "Early History of Vanuatu",
          topic: "Organization of Early Societies",
          learningOutcomes: ["State examples of different beliefs", "Describe political, social, economic situations", "List different land ownership systems"],
          activities: ["Belief systems mapping", "Social structure diagrams", "Land tenure case studies"],
          resources: ["Ethnographic studies", "Maps", "Guest speakers"],
          assessment: "Society structure poster"
        },
        {
          week: 9,
          strand: "Early History of Vanuatu",
          topic: "Traditional Values and Land Ownership",
          learningOutcomes: ["Explain different land ownership systems", "Discuss traditional values of customs", "Analyze matrilineal vs patrilineal systems"],
          activities: ["Land ownership debate", "Custom ceremony observation", "Value identification exercise"],
          resources: ["Land law documents", "Custom practice guides"],
          assessment: "Land ownership essay"
        },
        {
          week: 10,
          strand: "Early History of Vanuatu",
          topic: "Traditional Agriculture and Education",
          learningOutcomes: ["Identify different agricultural systems", "Describe features of traditional farming", "Compare Vanuatu's irrigation with world systems"],
          activities: ["Garden visit", "Agricultural method comparison", "Traditional tool study"],
          resources: ["Agricultural guides", "Photos of traditional gardens"],
          assessment: "Agricultural systems report"
        }
      ]
    },
    term2: {
      weeks: [
        {
          week: 1,
          strand: "Early History of Vanuatu",
          topic: "Roy Mata and the Shepherds",
          learningOutcomes: ["Identify Shepherds Group islands", "Describe Roy Mata's contributions", "Explain importance of Roy Mata"],
          activities: ["Map study of Shepherds", "Documentary viewing", "Peace process analysis"],
          resources: ["UNESCO materials", "Documentary films", "Archaeological reports"],
          assessment: "Roy Mata research project"
        },
        {
          week: 2,
          strand: "Early History of Vanuatu",
          topic: "Kuwae Volcanic Eruption",
          learningOutcomes: ["Locate Kuwae on map", "Analyze Roy Mata legend vs scientific evidence", "Understand volcanic impacts"],
          activities: ["Map plotting exercise", "Scientific evidence analysis", "Impact assessment"],
          resources: ["Geological reports", "Maps", "Scientific articles"],
          assessment: "Evidence analysis assignment"
        },
        {
          week: 3,
          strand: "Forces of Imperialism and Colonialism",
          topic: "Introduction to Imperialism",
          learningOutcomes: ["Define imperialism and colonialism", "Name examples of imperial powers", "Identify major Pacific colonial powers"],
          activities: ["Definition exercises", "Map coloring activity", "Timeline of colonial expansion"],
          resources: ["World maps", "Colonial history texts", "Timelines"],
          assessment: "Terminology quiz"
        },
        {
          week: 4,
          strand: "Forces of Imperialism and Colonialism",
          topic: "Motives for Imperial Expansion",
          learningOutcomes: ["Explain differences between imperialism and colonialism", "Describe main motives for expansion", "Analyze economic and political factors"],
          activities: ["Motive categorization", "Case study analysis", "Group discussion"],
          resources: ["Primary source documents", "Economic data"],
          assessment: "Motives essay"
        },
        {
          week: 5,
          strand: "Forces of Imperialism and Colonialism",
          topic: "Pacific Leadership Systems - Polynesia & Micronesia",
          learningOutcomes: ["Define aristocracy", "Name three Pacific cultural areas", "Explain aristocratic leadership establishment"],
          activities: ["Cultural area mapping", "Leadership comparison charts", "Case study: Samoa/Tonga"],
          resources: ["Pacific maps", "Cultural studies texts"],
          assessment: "Leadership systems comparison"
        },
        {
          week: 6,
          strand: "Forces of Imperialism and Colonialism",
          topic: "Democratic Leadership in Melanesia",
          learningOutcomes: ["Define democracy", "Identify Melanesian cultural area", "Explain Melanesian leadership systems"],
          activities: ["Democratic principles discussion", "Big Man system study", "Comparison activity"],
          resources: ["Melanesian studies texts", "Case studies"],
          assessment: "Melanesian leadership essay"
        },
        {
          week: 7,
          strand: "Interwar Period",
          topic: "Causes of World War I",
          learningOutcomes: ["State different causes of WWI", "Describe main features of WWI", "List Axis and Allied Powers"],
          activities: ["Cause mapping", "Alliance charting", "Documentary viewing"],
          resources: ["WWI documentaries", "Maps", "Primary sources"],
          assessment: "WWI causes diagram"
        },
        {
          week: 8,
          strand: "Interwar Period",
          topic: "Effects of WWI",
          learningOutcomes: ["Explain how causes led to WWI", "Evaluate effects on Europe", "Discuss effects on Pacific"],
          activities: ["Effect chain analysis", "Treaty of Versailles study", "Pacific impact research"],
          resources: ["Treaty documents", "Historical accounts"],
          assessment: "WWI effects essay"
        },
        {
          week: 9,
          strand: "Interwar Period",
          topic: "Origins of World War II",
          learningOutcomes: ["Name countries involved in WWII", "Outline causes of WWII", "Understand rise of fascism"],
          activities: ["Country mapping", "Cause analysis", "Leader profiles"],
          resources: ["WWII materials", "Biographical resources"],
          assessment: "WWII causes presentation"
        },
        {
          week: 10,
          strand: "Interwar Period",
          topic: "The Pacific War",
          learningOutcomes: ["Locate Pacific war zones", "Sketch WWII route into Pacific", "Explain how WWII entered Pacific"],
          activities: ["War zone mapping", "Pearl Harbor study", "Island hopping analysis"],
          resources: ["Pacific war maps", "Documentary films"],
          assessment: "Pacific War map project"
        }
      ]
    },
    term3: {
      weeks: [
        {
          week: 1,
          strand: "Interwar Period",
          topic: "Pacific Islander Involvement in WWII",
          learningOutcomes: ["Identify affected Pacific communities", "Compare impacts on directly/indirectly affected areas", "Understand local contributions"],
          activities: ["Community impact research", "Veteran stories collection", "Impact comparison chart"],
          resources: ["Local histories", "Interview recordings", "Photos"],
          assessment: "Local WWII history project"
        },
        {
          week: 2,
          strand: "Period of Decolonization",
          topic: "The New Hebrides Condominium",
          learningOutcomes: ["Define condominium", "Describe condominium governance", "Compare pre/post WWII political situations"],
          activities: ["Governance structure diagram", "Dual administration analysis", "Timeline creation"],
          resources: ["Condominium documents", "Historical photos"],
          assessment: "Condominium system essay"
        },
        {
          week: 3,
          strand: "Period of Decolonization",
          topic: "Pacific Political Situations Post-WWII",
          learningOutcomes: ["Select and study a Pacific territory", "Describe pre-colonial governance", "Explain differences in governance systems"],
          activities: ["Country case study", "Governance comparison", "Group presentations"],
          resources: ["Pacific nation profiles", "Colonial records"],
          assessment: "Country case study report"
        },
        {
          week: 4,
          strand: "Period of Decolonization",
          topic: "UN Role in Decolonization",
          learningOutcomes: ["Name UN-assisted countries", "Outline UN establishment", "Explain Universal Declaration of Human Rights"],
          activities: ["UN structure study", "Human rights analysis", "Declaration review"],
          resources: ["UN documents", "Human rights materials"],
          assessment: "UN role analysis"
        },
        {
          week: 5,
          strand: "From Independence to Present",
          topic: "Rise of National Liberation Movements",
          learningOutcomes: ["Define national consciousness", "List contributing factors", "Describe traditional nationalism features"],
          activities: ["Movement timeline", "Factor analysis", "Case study research"],
          resources: ["Independence movement documents", "Biographies"],
          assessment: "Liberation movement presentation"
        },
        {
          week: 6,
          strand: "From Independence to Present",
          topic: "Indigenous Movements in the Pacific",
          learningOutcomes: ["Name Pacific indigenous movements", "Match movements to islands", "Describe establishment motives"],
          activities: ["Movement mapping", "Motive analysis", "Comparative study"],
          resources: ["Pacific movement histories", "Documentary sources"],
          assessment: "Indigenous movement essay"
        },
        {
          week: 7,
          strand: "From Independence to Present",
          topic: "Indigenous Movements in Vanuatu",
          learningOutcomes: ["Name Vanuatu indigenous movements", "Describe movement challenges", "Discuss roles in decolonization"],
          activities: ["Nagriamel study", "John Frum analysis", "Movement comparison"],
          resources: ["Vanuatu history texts", "Documentary films"],
          assessment: "Vanuatu movements report"
        },
        {
          week: 8,
          strand: "From Independence to Present",
          topic: "Challenges to Independent Vanuatu",
          learningOutcomes: ["Define dual system", "Identify socio-cultural challenges", "List post-1980 challenges"],
          activities: ["Challenge categorization", "Franco-Anglo analysis", "Timeline creation"],
          resources: ["Independence documents", "News archives"],
          assessment: "Challenges analysis essay"
        },
        {
          week: 9,
          strand: "From Independence to Present",
          topic: "Anglophone vs Francophone Relations",
          learningOutcomes: ["Elaborate on Franco-Catholic/Anglo-Protestant relations", "Analyze causes of differences", "Understand reconciliation efforts"],
          activities: ["Relationship mapping", "Cause analysis", "Reconciliation study"],
          resources: ["Historical accounts", "Interview sources"],
          assessment: "Relations analysis presentation"
        },
        {
          week: 10,
          strand: "Review and Assessment",
          topic: "Year 11 History Review",
          learningOutcomes: ["Consolidate Year 11 learning", "Apply historical skills", "Prepare for examinations"],
          activities: ["Revision sessions", "Practice exams", "Group study"],
          resources: ["Review materials", "Past papers"],
          assessment: "End of year examination"
        }
      ]
    },
    term4: {
      weeks: [
        { week: 1, strand: "Extended Study", topic: "Independent Historical Research", learningOutcomes: ["Conduct independent research", "Apply research methodology", "Document findings"], activities: ["Research project work", "Source collection", "Data analysis"], resources: ["Library resources", "Online databases"], assessment: "Research progress review" },
        { week: 2, strand: "Extended Study", topic: "Research Writing Skills", learningOutcomes: ["Structure historical arguments", "Use evidence effectively", "Write academic prose"], activities: ["Writing workshops", "Peer review", "Draft development"], resources: ["Writing guides", "Sample essays"], assessment: "Draft submission" },
        { week: 3, strand: "Extended Study", topic: "Local History Project", learningOutcomes: ["Investigate local historical events", "Document community history", "Present findings"], activities: ["Community interviews", "Site visits", "Documentation"], resources: ["Recording equipment", "Interview guides"], assessment: "Local history presentation" },
        { week: 4, strand: "Extended Study", topic: "Historical Debates", learningOutcomes: ["Analyze historiographical debates", "Evaluate different interpretations", "Form reasoned conclusions"], activities: ["Debate preparation", "Class debates", "Position papers"], resources: ["Historiography texts", "Debate guides"], assessment: "Debate participation" },
        { week: 5, strand: "Extended Study", topic: "Digital History", learningOutcomes: ["Use digital tools for history", "Create digital presentations", "Evaluate online sources"], activities: ["Digital archive exploration", "Presentation creation", "Online source evaluation"], resources: ["Digital archives", "Presentation software"], assessment: "Digital presentation" },
        { week: 6, strand: "Review", topic: "Term 4 Consolidation", learningOutcomes: ["Review extended learning", "Consolidate research skills", "Prepare portfolio"], activities: ["Portfolio compilation", "Skills review", "Peer assessment"], resources: ["Portfolio guidelines"], assessment: "Portfolio review" },
        { week: 7, strand: "Review", topic: "Year 11 Comprehensive Review", learningOutcomes: ["Review all Year 11 content", "Identify areas for improvement", "Prepare for Year 12"], activities: ["Comprehensive revision", "Gap analysis", "Goal setting"], resources: ["Year 11 materials"], assessment: "Comprehensive test" },
        { week: 8, strand: "Assessment", topic: "Final Assessment", learningOutcomes: ["Demonstrate Year 11 mastery", "Complete final assessments", "Reflect on learning"], activities: ["Final examination", "Project submission", "Reflection writing"], resources: ["Exam materials"], assessment: "End of year examination" }
      ]
    }
  },
  year12: {
    term1: {
      weeks: [
        {
          week: 1,
          strand: "Skills of History",
          topic: "Gathering Historical Information",
          learningOutcomes: ["Identify methods for gathering information", "State advantages/disadvantages of methods", "Apply information gathering techniques"],
          activities: ["Method demonstration", "Source collection practice", "Comparative analysis"],
          resources: ["Research guides", "Various source types"],
          assessment: "Information gathering exercise"
        },
        {
          week: 2,
          strand: "Skills of History",
          topic: "Analyzing Non-Verbal Texts",
          learningOutcomes: ["Name varieties of non-verbal texts", "Describe importance of visual sources", "Interpret messages in non-verbal texts"],
          activities: ["Photo analysis", "Map interpretation", "Cartoon analysis"],
          resources: ["Historical photos", "Political cartoons", "Maps"],
          assessment: "Non-verbal text analysis"
        },
        {
          week: 3,
          strand: "Skills of History",
          topic: "Examining Written Sources",
          learningOutcomes: ["Identify verbal text examples", "Assess publication dates importance", "Evaluate writer status"],
          activities: ["Document analysis", "Source comparison", "Author evaluation"],
          resources: ["Historical documents", "Academic articles"],
          assessment: "Written source analysis"
        },
        {
          week: 4,
          strand: "Skills of History",
          topic: "Evaluating Historical Sources",
          learningOutcomes: ["Identify important historical sources", "Assess source reliability", "Compare primary/secondary reliability"],
          activities: ["Source evaluation practice", "Reliability ranking", "Cross-referencing exercise"],
          resources: ["Multiple source types", "Evaluation rubrics"],
          assessment: "Source evaluation assignment"
        },
        {
          week: 5,
          strand: "Early History of Vanuatu",
          topic: "Early European Contact",
          learningOutcomes: ["Name early Europeans in Vanuatu", "State early transportation modes", "Match Europeans to countries of origin"],
          activities: ["Explorer profiles", "Route mapping", "Timeline creation"],
          resources: ["Explorer biographies", "Historical maps"],
          assessment: "Explorer research project"
        },
        {
          week: 6,
          strand: "Early History of Vanuatu",
          topic: "European Exploration Routes",
          learningOutcomes: ["Sketch route maps", "Explain reasons for European arrival", "Evaluate primary sources about contact"],
          activities: ["Map drawing", "Motive analysis", "Source evaluation"],
          resources: ["Navigation maps", "Ship logs", "Diaries"],
          assessment: "Exploration map project"
        },
        {
          week: 7,
          strand: "Early History of Vanuatu",
          topic: "Impacts of Early European Contact",
          learningOutcomes: ["Name introduced goods", "List changes to society", "Describe positive and negative effects"],
          activities: ["Impact categorization", "Change timeline", "Debate activity"],
          resources: ["Trade records", "Historical accounts"],
          assessment: "Impact analysis essay"
        },
        {
          week: 8,
          strand: "Early History of Vanuatu",
          topic: "Labour Trade",
          learningOutcomes: ["Define labour trade", "Identify groups involved", "List features of Pacific labour trade"],
          activities: ["Definition exercise", "Stakeholder mapping", "Case study analysis"],
          resources: ["Labour trade documents", "Plantation records"],
          assessment: "Labour trade report"
        },
        {
          week: 9,
          strand: "Early History of Vanuatu",
          topic: "Impacts of Labour Trade",
          learningOutcomes: ["Explain labour trade initiation reasons", "Evaluate impacts on Pacific", "Analyze long-term consequences"],
          activities: ["Cause-effect analysis", "Impact assessment", "Documentary viewing"],
          resources: ["Documentary films", "Academic studies"],
          assessment: "Labour trade impact essay"
        },
        {
          week: 10,
          strand: "Early History of Vanuatu",
          topic: "Colonial Administrators",
          learningOutcomes: ["Define colonial power", "Name New Hebrides administrators", "Define Condominium Rule"],
          activities: ["Administrator profiles", "Governance comparison", "Structure diagrams"],
          resources: ["Colonial records", "Administrative documents"],
          assessment: "Colonial administration quiz"
        }
      ]
    },
    term2: {
      weeks: [
        {
          week: 1,
          strand: "Early History of Vanuatu",
          topic: "French and British Administration Compared",
          learningOutcomes: ["Discuss contrasting Condominium features", "Evaluate ruling objectives achievement", "Analyze dual system impacts"],
          activities: ["Comparison charts", "Objective analysis", "Case studies"],
          resources: ["Administrative records", "Policy documents"],
          assessment: "Comparison essay"
        },
        {
          week: 2,
          strand: "Forces of Imperialism",
          topic: "Imperialism vs Colonialism",
          learningOutcomes: ["Define imperialism concept", "Define colonialism concept", "List features of both"],
          activities: ["Concept mapping", "Feature identification", "Historical examples"],
          resources: ["Academic texts", "Case studies"],
          assessment: "Concept definition test"
        },
        {
          week: 3,
          strand: "Forces of Imperialism",
          topic: "Comparing Imperial Systems",
          learningOutcomes: ["Compare colonialism and imperialism", "Analyze positive/negative impacts", "Apply concepts to Pacific"],
          activities: ["Venn diagram creation", "Impact analysis", "Pacific case studies"],
          resources: ["Comparative texts", "Regional studies"],
          assessment: "Imperial systems comparison"
        },
        {
          week: 4,
          strand: "Forces of Imperialism",
          topic: "German Imperialism - Samoa Focus",
          learningOutcomes: ["Locate Germany on map", "Identify German Pacific territories", "Describe German expansion process"],
          activities: ["Map work", "Expansion timeline", "Samoa case study"],
          resources: ["German colonial records", "Samoan histories"],
          assessment: "German imperialism report"
        },
        {
          week: 5,
          strand: "Forces of Imperialism",
          topic: "British Indirect Rule",
          learningOutcomes: ["Define indirect rule", "Locate Britain on map", "Describe indirect rule system"],
          activities: ["System analysis", "Fiji case study", "Advantage/disadvantage listing"],
          resources: ["British colonial records", "Fijian histories"],
          assessment: "Indirect rule analysis"
        },
        {
          week: 6,
          strand: "Forces of Imperialism",
          topic: "French Direct Rule",
          learningOutcomes: ["Define direct rule", "Identify French colonization process", "Name French Pacific territories"],
          activities: ["System comparison", "New Caledonia study", "Policy analysis"],
          resources: ["French colonial records", "New Caledonian histories"],
          assessment: "Direct rule essay"
        },
        {
          week: 7,
          strand: "Interwar Period",
          topic: "WWII Impacts on Pacific",
          learningOutcomes: ["Identify affected Pacific areas", "Describe WWII effects", "Explain societal changes"],
          activities: ["Impact mapping", "Before/after comparison", "Documentary analysis"],
          resources: ["WWII Pacific records", "Documentary films"],
          assessment: "WWII Pacific impact project"
        },
        {
          week: 8,
          strand: "Interwar Period",
          topic: "Pacific Islanders in WWII",
          learningOutcomes: ["Name islands with local involvement", "Describe roles played", "Explain significance of contributions"],
          activities: ["Role categorization", "Contribution analysis", "Personal stories research"],
          resources: ["War records", "Personal accounts"],
          assessment: "Pacific contribution report"
        },
        {
          week: 9,
          strand: "Interwar Period",
          topic: "Effects of WWII on Pacific Islanders",
          learningOutcomes: ["Identify different effects", "Describe positive/negative impacts", "Explain attitude changes"],
          activities: ["Effect categorization", "Community impact study", "Attitude shift analysis"],
          resources: ["Post-war studies", "Interview records"],
          assessment: "WWII effects analysis"
        },
        {
          week: 10,
          strand: "Interwar Period",
          topic: "The Cold War",
          learningOutcomes: ["Define Cold War", "Describe main features", "Explain WWII-Cold War connection"],
          activities: ["Definition exercises", "Feature mapping", "Timeline creation"],
          resources: ["Cold War texts", "Documentary films"],
          assessment: "Cold War quiz"
        }
      ]
    },
    term3: {
      weeks: [
        {
          week: 1,
          strand: "Interwar Period",
          topic: "Cold War Impacts on Pacific",
          learningOutcomes: ["Discuss Pacific Cold War impacts", "Analyze nuclear testing effects", "Understand strategic importance"],
          activities: ["Impact analysis", "Nuclear testing study", "Strategic mapping"],
          resources: ["Cold War Pacific studies", "Nuclear test records"],
          assessment: "Cold War Pacific essay"
        },
        {
          week: 2,
          strand: "Period of Decolonization",
          topic: "Decolonization by War",
          learningOutcomes: ["Name countries using war for independence", "Describe independence wars", "Explain war as decolonization method"],
          activities: ["War for independence mapping", "Case study: Algeria/Vietnam", "Method analysis"],
          resources: ["Independence war histories", "Documentary films"],
          assessment: "War decolonization report"
        },
        {
          week: 3,
          strand: "Period of Decolonization",
          topic: "Decolonization by Political Unrest",
          learningOutcomes: ["Name countries using political unrest", "Describe political movements", "Explain strategies used"],
          activities: ["Movement analysis", "Case study: India", "Strategy identification"],
          resources: ["Political movement histories", "Gandhi biography"],
          assessment: "Political unrest essay"
        },
        {
          week: 4,
          strand: "Period of Decolonization",
          topic: "Peaceful Decolonization",
          learningOutcomes: ["Name countries using negotiation", "Describe negotiation processes", "Compare peaceful vs violent methods"],
          activities: ["Negotiation case studies", "Method comparison", "Outcome analysis"],
          resources: ["Negotiation records", "Comparative studies"],
          assessment: "Peaceful decolonization analysis"
        },
        {
          week: 5,
          strand: "Period of Decolonization",
          topic: "Pacific Decolonization",
          learningOutcomes: ["Identify independent Pacific countries", "Describe decolonization processes", "Explain influencing factors"],
          activities: ["Pacific independence timeline", "Process comparison", "Factor analysis"],
          resources: ["Pacific independence records", "Country profiles"],
          assessment: "Pacific decolonization project"
        },
        {
          week: 6,
          strand: "From Independence to Present",
          topic: "New Political Parties",
          learningOutcomes: ["Name emerging political parties", "Describe party ideologies", "Explain party goals"],
          activities: ["Party profiles", "Ideology mapping", "Goal analysis"],
          resources: ["Political party histories", "Manifestos"],
          assessment: "Political party report"
        },
        {
          week: 7,
          strand: "From Independence to Present",
          topic: "Pacific Political Parties",
          learningOutcomes: ["Name Pacific political parties", "Describe party features", "Explain nation-building contributions"],
          activities: ["Party comparison", "Feature identification", "Contribution analysis"],
          resources: ["Pacific political histories", "Party documents"],
          assessment: "Pacific parties comparison"
        },
        {
          week: 8,
          strand: "From Independence to Present",
          topic: "Two Political Ideologies in New Hebrides",
          learningOutcomes: ["Name major pre-independence ideologies", "Describe ideology features", "Explain political shaping"],
          activities: ["Ideology mapping", "VP vs Moderate analysis", "Political development study"],
          resources: ["Vanuatu political histories", "Party documents"],
          assessment: "Ideologies essay"
        },
        {
          week: 9,
          strand: "From Independence to Present",
          topic: "Internal Political Conflicts",
          learningOutcomes: ["Identify main political conflicts", "Describe conflict causes", "Explain impacts on Vanuatu"],
          activities: ["Conflict mapping", "Cause analysis", "Impact assessment"],
          resources: ["Political conflict records", "News archives"],
          assessment: "Conflict analysis report"
        },
        {
          week: 10,
          strand: "Review and Assessment",
          topic: "Year 12 History Review",
          learningOutcomes: ["Consolidate Year 12 learning", "Apply advanced historical skills", "Prepare for examinations"],
          activities: ["Revision sessions", "Practice exams", "Essay preparation"],
          resources: ["Review materials", "Past papers"],
          assessment: "End of year examination"
        }
      ]
    },
    term4: {
      weeks: [
        { week: 1, strand: "Extended Study", topic: "Advanced Research Project", learningOutcomes: ["Design complex research", "Apply advanced methodology", "Analyze multiple sources"], activities: ["Project development", "Source analysis", "Research writing"], resources: ["Academic databases", "Research guides"], assessment: "Research proposal" },
        { week: 2, strand: "Extended Study", topic: "Historiographical Analysis", learningOutcomes: ["Compare historical interpretations", "Analyze bias and perspective", "Evaluate historical debates"], activities: ["Historiography study", "Comparative analysis", "Critical evaluation"], resources: ["Historiography texts", "Journal articles"], assessment: "Historiographical essay" },
        { week: 3, strand: "Extended Study", topic: "Pacific History Perspectives", learningOutcomes: ["Explore Pacific historical narratives", "Analyze regional connections", "Understand decolonization"], activities: ["Regional history study", "Comparative analysis", "Discussion groups"], resources: ["Pacific history texts", "Regional archives"], assessment: "Regional analysis paper" },
        { week: 4, strand: "Extended Study", topic: "Oral History Methods", learningOutcomes: ["Conduct oral history interviews", "Document testimonies", "Analyze oral sources"], activities: ["Interview practice", "Recording sessions", "Transcription work"], resources: ["Recording equipment", "Interview guides"], assessment: "Oral history project" },
        { week: 5, strand: "Extended Study", topic: "Historical Presentation Skills", learningOutcomes: ["Present historical findings", "Use visual aids effectively", "Engage audiences"], activities: ["Presentation preparation", "Peer feedback", "Public speaking practice"], resources: ["Presentation tools", "Visual aids"], assessment: "Formal presentation" },
        { week: 6, strand: "Review", topic: "Term 4 Consolidation", learningOutcomes: ["Review extended studies", "Consolidate advanced skills", "Prepare for Year 13"], activities: ["Skills consolidation", "Portfolio review", "Goal setting"], resources: ["Review materials"], assessment: "Skills assessment" },
        { week: 7, strand: "Review", topic: "Year 12 Comprehensive Review", learningOutcomes: ["Review all Year 12 content", "Prepare for final exams", "Set Year 13 goals"], activities: ["Comprehensive revision", "Practice assessments", "Future planning"], resources: ["Year 12 materials"], assessment: "Comprehensive review" },
        { week: 8, strand: "Assessment", topic: "Final Assessment", learningOutcomes: ["Demonstrate Year 12 mastery", "Complete all assessments", "Transition to Year 13"], activities: ["Final examination", "Project completion", "Reflection"], resources: ["Exam materials"], assessment: "End of year examination" }
      ]
    }
  },
  year13: {
    term1: {
      weeks: [
        {
          week: 1,
          strand: "Skills of History",
          topic: "History and Career Connections",
          learningOutcomes: ["Define careers requiring historical knowledge", "Understand research methodology", "Plan historical investigation"],
          activities: ["Career exploration", "Research planning", "Topic selection"],
          resources: ["Career guides", "Research methodology texts"],
          assessment: "Career connection presentation"
        },
        {
          week: 2,
          strand: "Skills of History",
          topic: "Designing Historical Investigations",
          learningOutcomes: ["Design investigation plan", "Apply historical skills", "Select appropriate methodology"],
          activities: ["Plan development", "Skill application", "Methodology selection"],
          resources: ["Research guides", "Sample investigations"],
          assessment: "Investigation plan submission"
        },
        {
          week: 3,
          strand: "Skills of History",
          topic: "Conducting Historical Research",
          learningOutcomes: ["Select appropriate topic", "Apply research methodology", "Gather relevant sources"],
          activities: ["Research implementation", "Source gathering", "Data collection"],
          resources: ["Library resources", "Archive access"],
          assessment: "Research progress report"
        },
        {
          week: 4,
          strand: "Skills of History",
          topic: "Presenting Research Findings",
          learningOutcomes: ["Identify presentation formats", "Apply historical conventions", "Create comprehensive presentations"],
          activities: ["Format selection", "Convention application", "Presentation creation"],
          resources: ["Presentation guides", "Sample formats"],
          assessment: "Research presentation"
        },
        {
          week: 5,
          strand: "Early History of Vanuatu",
          topic: "Joint Naval Commission",
          learningOutcomes: ["Define Joint Naval Commission", "Describe commission purposes", "Explain reasons for establishment"],
          activities: ["Commission analysis", "Purpose identification", "Historical context study"],
          resources: ["Commission documents", "Historical records"],
          assessment: "Commission analysis essay"
        },
        {
          week: 6,
          strand: "Early History of Vanuatu",
          topic: "The 1906 Convention",
          learningOutcomes: ["State 1906 Convention year", "Describe convention terms", "Explain convention reasons"],
          activities: ["Convention study", "Term analysis", "Context mapping"],
          resources: ["Convention documents", "Historical analyses"],
          assessment: "Convention terms quiz"
        },
        {
          week: 7,
          strand: "Early History of Vanuatu",
          topic: "The 1914 Protocol",
          learningOutcomes: ["State Protocol purpose", "Describe Protocol terms", "Evaluate usefulness to locals"],
          activities: ["Protocol analysis", "Impact assessment", "Critical evaluation"],
          resources: ["Protocol documents", "Local impact studies"],
          assessment: "Protocol impact essay"
        },
        {
          week: 8,
          strand: "Early History of Vanuatu",
          topic: "The Condominium Regime",
          learningOutcomes: ["Define Condominium regime", "Describe government structure", "Explain Condominium operations"],
          activities: ["Structure mapping", "Operations analysis", "Comparison with other systems"],
          resources: ["Condominium records", "Government documents"],
          assessment: "Condominium structure diagram"
        },
        {
          week: 9,
          strand: "Early History of Vanuatu",
          topic: "Condominium Impacts",
          learningOutcomes: ["Evaluate Condominium impacts", "Analyze long-term effects", "Assess legacy"],
          activities: ["Impact assessment", "Legacy analysis", "Critical evaluation"],
          resources: ["Impact studies", "Historical analyses"],
          assessment: "Condominium impact essay"
        },
        {
          week: 10,
          strand: "Forces of Imperialism",
          topic: "Forces Driving Imperial Expansion",
          learningOutcomes: ["Define driving forces", "Describe motivations", "Analyze economic/political/social forces"],
          activities: ["Force identification", "Motivation analysis", "Multi-factor assessment"],
          resources: ["Imperial studies", "Economic analyses"],
          assessment: "Forces analysis report"
        }
      ]
    },
    term2: {
      weeks: [
        {
          week: 1,
          strand: "Forces of Imperialism",
          topic: "Pacific Partition",
          learningOutcomes: ["Identify partition patterns", "Describe partition process", "Explain administrative patterns"],
          activities: ["Partition mapping", "Pattern analysis", "Comparative study"],
          resources: ["Colonial maps", "Partition records"],
          assessment: "Partition map project"
        },
        {
          week: 2,
          strand: "Forces of Imperialism",
          topic: "Comparing Imperial Administration",
          learningOutcomes: ["Compare administrative approaches", "Analyze different colonial styles", "Evaluate effectiveness"],
          activities: ["Administration comparison", "Style analysis", "Effectiveness assessment"],
          resources: ["Administrative records", "Comparative studies"],
          assessment: "Administration comparison essay"
        },
        {
          week: 3,
          strand: "Forces of Imperialism",
          topic: "Impacts of Imperial Expansion",
          learningOutcomes: ["Identify expansion impacts", "Describe social impacts", "Analyze economic changes"],
          activities: ["Impact categorization", "Social impact study", "Economic analysis"],
          resources: ["Impact studies", "Economic records"],
          assessment: "Imperial impact report"
        },
        {
          week: 4,
          strand: "Forces of Imperialism",
          topic: "Long-term Imperial Legacy",
          learningOutcomes: ["Evaluate long-term impacts", "Analyze continuing effects", "Assess colonial legacy"],
          activities: ["Legacy assessment", "Continuing impact study", "Critical analysis"],
          resources: ["Legacy studies", "Contemporary analyses"],
          assessment: "Legacy analysis essay"
        },
        {
          week: 5,
          strand: "Interwar Period",
          topic: "Political and Administrative Changes",
          learningOutcomes: ["Identify post-WWII political changes", "Describe administrative reforms", "Explain governance changes"],
          activities: ["Change mapping", "Reform analysis", "Governance comparison"],
          resources: ["Reform records", "Political histories"],
          assessment: "Political change report"
        },
        {
          week: 6,
          strand: "Interwar Period",
          topic: "Environmental Impacts of WWII",
          learningOutcomes: ["Identify environmental damage", "Describe specific impacts", "Analyze recovery efforts"],
          activities: ["Damage assessment", "Impact mapping", "Recovery study"],
          resources: ["Environmental reports", "Recovery plans"],
          assessment: "Environmental impact essay"
        },
        {
          week: 7,
          strand: "Interwar Period",
          topic: "Attitude Changes and Decolonization",
          learningOutcomes: ["Identify attitude changes", "Describe American influence", "Explain acceleration of decolonization"],
          activities: ["Attitude analysis", "Influence assessment", "Connection mapping"],
          resources: ["Post-war studies", "Interview records"],
          assessment: "Attitude change analysis"
        },
        {
          week: 8,
          strand: "Period of Decolonization",
          topic: "Asian and African Decolonization",
          learningOutcomes: ["Name independent countries", "Describe decolonization processes", "Explain influencing factors"],
          activities: ["Country case studies", "Process comparison", "Factor analysis"],
          resources: ["Decolonization histories", "Country profiles"],
          assessment: "Comparative decolonization essay"
        },
        {
          week: 9,
          strand: "Period of Decolonization",
          topic: "Pacific Decolonization Comparison",
          learningOutcomes: ["Name independent Pacific countries", "Describe independence processes", "Compare experiences"],
          activities: ["Pacific independence study", "Process analysis", "Comparative assessment"],
          resources: ["Pacific histories", "Independence records"],
          assessment: "Pacific comparison project"
        },
        {
          week: 10,
          strand: "Period of Decolonization",
          topic: "Emergence of Third World Countries",
          learningOutcomes: ["Define third world countries", "Describe characteristics", "Explain development challenges"],
          activities: ["Characteristic identification", "Challenge analysis", "Development study"],
          resources: ["Development studies", "Country profiles"],
          assessment: "Third world analysis"
        }
      ]
    },
    term3: {
      weeks: [
        {
          week: 1,
          strand: "From Independence to Present",
          topic: "From New Hebrides to Vanuatu",
          learningOutcomes: ["State independence date", "Describe events leading to independence", "Explain name change significance"],
          activities: ["Independence timeline", "Event analysis", "Significance study"],
          resources: ["Independence records", "Historical accounts"],
          assessment: "Independence story project"
        },
        {
          week: 2,
          strand: "From Independence to Present",
          topic: "Vanuatu's Nation-Building",
          learningOutcomes: ["Evaluate nation-building approach", "Analyze development strategies", "Assess early challenges"],
          activities: ["Approach evaluation", "Strategy analysis", "Challenge assessment"],
          resources: ["Development plans", "Government records"],
          assessment: "Nation-building essay"
        },
        {
          week: 3,
          strand: "From Independence to Present",
          topic: "Vanuatu's Regional Affiliations",
          learningOutcomes: ["Identify regional affiliations", "Describe foreign policy objectives", "Explain regional organization roles"],
          activities: ["Affiliation mapping", "Policy analysis", "Organization study"],
          resources: ["Foreign policy documents", "Regional organization records"],
          assessment: "Regional role report"
        },
        {
          week: 4,
          strand: "From Independence to Present",
          topic: "Vanuatu's Regional Policy Since 1991",
          learningOutcomes: ["Evaluate post-1991 regional policy", "Analyze policy evolution", "Assess current directions"],
          activities: ["Policy evaluation", "Evolution tracking", "Direction assessment"],
          resources: ["Policy documents", "Contemporary analyses"],
          assessment: "Policy analysis essay"
        },
        {
          week: 5,
          strand: "Historical Investigation",
          topic: "Research Project Development",
          learningOutcomes: ["Develop comprehensive research project", "Apply all historical skills", "Create original historical work"],
          activities: ["Project development", "Skill integration", "Original research"],
          resources: ["All available resources", "Mentor guidance"],
          assessment: "Research project progress"
        },
        {
          week: 6,
          strand: "Historical Investigation",
          topic: "Research Project Implementation",
          learningOutcomes: ["Implement research methodology", "Gather and analyze sources", "Develop findings"],
          activities: ["Methodology implementation", "Source analysis", "Finding development"],
          resources: ["Selected sources", "Analysis tools"],
          assessment: "Research implementation report"
        },
        {
          week: 7,
          strand: "Historical Investigation",
          topic: "Research Project Completion",
          learningOutcomes: ["Complete research analysis", "Draw conclusions", "Prepare presentation"],
          activities: ["Analysis completion", "Conclusion drawing", "Presentation preparation"],
          resources: ["Presentation tools", "Format guides"],
          assessment: "Draft submission"
        },
        {
          week: 8,
          strand: "Historical Investigation",
          topic: "Research Presentation",
          learningOutcomes: ["Present research findings", "Defend conclusions", "Demonstrate historical understanding"],
          activities: ["Presentation delivery", "Q&A session", "Peer feedback"],
          resources: ["Presentation equipment", "Evaluation rubrics"],
          assessment: "Final presentation"
        },
        {
          week: 9,
          strand: "Review",
          topic: "Year 13 History Review",
          learningOutcomes: ["Consolidate all Year 13 learning", "Integrate historical knowledge", "Prepare for final assessment"],
          activities: ["Comprehensive revision", "Integration exercises", "Exam preparation"],
          resources: ["All course materials", "Past papers"],
          assessment: "Practice examination"
        },
        {
          week: 10,
          strand: "Final Assessment",
          topic: "Year 13 Final Examination",
          learningOutcomes: ["Demonstrate mastery of historical skills", "Apply knowledge comprehensively", "Complete senior secondary History"],
          activities: ["Final examination", "Course completion"],
          resources: ["Examination materials"],
          assessment: "End of year examination"
        }
      ]
    },
    term4: {
      weeks: [
        { week: 1, strand: "Extended Study", topic: "Independent Research Completion", learningOutcomes: ["Complete research project", "Finalize documentation", "Prepare for submission"], activities: ["Research completion", "Final editing", "Submission preparation"], resources: ["Research materials"], assessment: "Research submission" },
        { week: 2, strand: "Extended Study", topic: "Historical Legacy Projects", learningOutcomes: ["Create lasting historical records", "Document community history", "Leave educational legacy"], activities: ["Legacy project work", "Documentation", "Community engagement"], resources: ["Project materials"], assessment: "Legacy project" },
        { week: 3, strand: "Extended Study", topic: "Advanced Historiography", learningOutcomes: ["Master historiographical debates", "Contribute to historical discussions", "Develop scholarly voice"], activities: ["Advanced analysis", "Scholarly writing", "Academic discussion"], resources: ["Academic journals", "Historiography texts"], assessment: "Scholarly essay" },
        { week: 4, strand: "Extended Study", topic: "History and Current Affairs", learningOutcomes: ["Connect history to present", "Analyze contemporary issues historically", "Apply historical thinking"], activities: ["Current events analysis", "Historical connections", "Discussion groups"], resources: ["News sources", "Historical context materials"], assessment: "Contemporary analysis" },
        { week: 5, strand: "Preparation", topic: "University and Career Preparation", learningOutcomes: ["Prepare for further study", "Understand career pathways", "Plan next steps"], activities: ["University exploration", "Career planning", "Application preparation"], resources: ["University guides", "Career information"], assessment: "Future planning portfolio" },
        { week: 6, strand: "Review", topic: "Term 4 Consolidation", learningOutcomes: ["Review all extended studies", "Consolidate Year 13 learning", "Reflect on growth"], activities: ["Comprehensive review", "Reflection writing", "Portfolio completion"], resources: ["All materials"], assessment: "Final portfolio" },
        { week: 7, strand: "Review", topic: "Senior History Comprehensive Review", learningOutcomes: ["Review all senior History content", "Demonstrate comprehensive understanding", "Celebrate achievement"], activities: ["Final revision", "Celebration activities", "Farewell ceremonies"], resources: ["Review materials"], assessment: "Comprehensive assessment" },
        { week: 8, strand: "Assessment", topic: "Final Assessment and Graduation", learningOutcomes: ["Complete all final assessments", "Graduate from History program", "Transition to next phase"], activities: ["Final examination", "Graduation activities", "Certificate presentation"], resources: ["Exam and graduation materials"], assessment: "Final examination and graduation" }
      ]
    }
  }
};

export default historyWeeklyLessons;
